import { ToastComponent } from './toast.component';
import {
  afterNextRender,
  Component,
  ElementRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ToasterService } from './toaster.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'toaster',
  imports: [ToastComponent, CommonModule],
  templateUrl: 'toaster.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: 'toaster.component.css',
})
export class ToasterComponent {
  private toasterService = inject(ToasterService);
  public hostEl = inject(ElementRef);

  toasts = this.toasterService.toasts;

  constructor() {
    afterNextRender(() => {
      document.body.appendChild(this.hostEl.nativeElement);
    });
  }
}
